// extracted by mini-css-extract-plugin
export default {"message":"submission-success_message__aS+KW","icon":"submission-success_icon__g14Fu"};